import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PortalModule } from 'app/portal/portal.module';
import { AuthGuard, PrepareGuard, PendingChangesGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';

import { ConfirmationOverviewComponent } from './confirmation-overview/confirmation-overview.component';
import { ConfirmationMessageComponent } from './confirmation-message/confirmation-message.component';
import { ConfirmationMessageDialogComponent } from './confirmation-message-dialog/confirmation-message-dialog.component';
import { ConfirmationEmailDialogComponent } from './confirmation-email-dialog/confirmation-email-dialog.component';
import { ConfirmationHistoryComponent } from './confirmation-history/confirmation-history.component';




@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        PortalModule,
        RouterModule.forChild([
            {
                path: 'confirmations',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    { path: 'overview', component: ConfirmationOverviewComponent, data: { title: 'Confirmations Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'messages', component: ConfirmationMessageComponent, data: { title: 'Confirmation Messages' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'history', component: ConfirmationHistoryComponent, data: { title: 'Confirmations History' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: ':id', component: ConfirmationOverviewComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        ConfirmationOverviewComponent,
        ConfirmationMessageComponent,
        ConfirmationMessageDialogComponent,
        ConfirmationEmailDialogComponent,
        ConfirmationHistoryComponent
    ]
})
export class ConfirmationsModule {}
